import {createSlice} from "@reduxjs/toolkit";
import {getUser, addUser, updateUser, deleteUser, exportUsersThunk} from './thunk';

export const initialState: any = {
    userLists: [],
    error: {},
    isLoading: false,
};

const UserSlice = createSlice({
    name: 'UserSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUser.pending, (state: any, action: any) => {
            state.isLoading = true;
        });

        builder.addCase(getUser.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.userLists = action.payload.data;
        });
        builder.addCase(getUser.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload.error || null;
        });
        //Add User
        builder.addCase(addUser.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(addUser.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.userLists = [...state.userLists, action.payload.data ? action.payload.data : action.payload];
        });

        builder.addCase(addUser.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });
        
        //UpdateUser
        builder.addCase(updateUser.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(updateUser.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.userLists = state.userLists.map((user: any) =>
                user.id === action.meta.arg.id
                    ? {...user, ...action.meta.arg}
                    : user
            );
        });

        builder.addCase(updateUser.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

        //Delete User
        builder.addCase(deleteUser.pending, (state: any) => {
            state.isLoading = true;
        });
        builder.addCase(deleteUser.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
            state.userLists = (state.userLists || []).filter((product: any) => product.id !== action.payload.id);
        });
        builder.addCase(deleteUser.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload?.error || action.payload || null;
        });

        //Export User
        builder.addCase(exportUsersThunk.fulfilled, (state: any, action: any) => {
            state.isLoading = false;
        });
        builder.addCase(exportUsersThunk.rejected, (state: any, action: any) => {
            state.isLoading = false;
            state.error = action.payload.error || null;
        });
        builder.addCase(exportUsersThunk.pending, (state: any, action: any) => {
            state.isLoading = true;
        });

    }
});

export default UserSlice.reducer;
